(ns frontend.view.reports.custom.alj-2.active-deals-per-industry-bar-chart
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]
   [reagent.core :as r]))

(defn bar-deals-per-industry
  [deals]
  (let [asset-industry-frequencies (->> deals
                                        (keep (fn [oppo]
                                                (get @session/entities (:oppo/target-asset oppo))))
                                        (mapcat :asset/tag-industry)
                                        (frequencies)
                                        (sort-by second)
                                        (reverse))
        other-count (->> asset-industry-frequencies
                         (drop 9)
                         (keep second)
                         (apply +))
        other-names (->> asset-industry-frequencies
                         (drop 9)
                         (keep first)
                         (map (fn [tag-id]
                                (entity/display-string (get @session/entities tag-id))))
                         (doall))]
    [{:series [{:name (loc/tr :asset/tag-industry)
                :data (concat (->> asset-industry-frequencies
                                   (take 9)
                                   (map (fn [[tag-id deal-count]]
                                          (let [tag (get @session/entities tag-id)]
                                            {:name (entity/display-string tag)
                                             :y    deal-count})))
                                   (vec))
                              (when (and (number? other-count)
                                         (pos? other-count))
                                [{:name (loc/tr :other)
                                  :y    other-count}]))}]}
     (seq other-names)]))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (r/atom (alj-utils/default-date-range-state state))]
    (fn []
      (let [active-deals (->> (alj/active-deals)
                              (alj-utils/deals-in-date-range :common/created-on date-state-atom))
            [chart-data other-names] (bar-deals-per-industry active-deals)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (doall))
            view-name (loc/tr :total-active-deals-by-asset-tag-industry)]
        [alj-components/alj-bar-chart
         {:view-name       view-name
          :total-deals     (count active-deals)
          :total-amount    (alj-utils/ticket-size-sum-billions active-deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom
          :footer-content  (when other-names
                             [:ol.pl-4.pb-4.mr-4.ml-4
                              [:li.text-size--sm "Others include: "
                               (string/join ", " other-names)]])}]))))

